import React from "react";

import styled from "styled-components/macro";

import { AddressProvider } from "./AddressContext";

export function FnrAddress({ children, style }) {
  return (
    <AddressProvider>
      <Wrapper data-cy="fnrAddress" style={style}>
        {children}
      </Wrapper>
    </AddressProvider>
  );
}

const Wrapper = styled.div`
  box-sizing: border-box;
  background-color: white;
  border-radius: 8px;
  display: flex;

  @media (max-width: 430px) {
    input {
      font-size: 15px !important;
    }
  }
`;
